// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Remanet design tokens ───────────────────────────────────────────────── */
:root {
  --rm-primary:        #269044;
  --rm-primary-hover:  #1e7438;
  --rm-primary-dim:    rgba(38, 144, 68, 0.10);
  --rm-primary-border: rgba(38, 144, 68, 0.4);

  --rm-bg:             #f1f1f1;
  --rm-surface:        #ffffff;
  --rm-surface-raised: #f8f8f8;
  --rm-border:         #d3d3d3;
  --rm-border-light:   #e8e8e8;

  --rm-text:           #202020;
  --rm-text-muted:     #7c7c7c;

  --rm-radius:         6px;
  --rm-radius-lg:      10px;
  --rm-transition:     0.2s ease;

  --rm-shadow-sm:      0 1px 3px rgba(0,0,0,0.07);
  --rm-shadow-md:      0 2px 8px rgba(0,0,0,0.09);
  --rm-header-height:  60px;

  /* Panel label style (reusable as JS object reference) */
  --rm-label-size:     11px;
  --rm-label-spacing:  0.08em;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background-color: var(--rm-bg);
  color: var(--rm-text);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  overflow-x: hidden;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

/* ── Scrollbar (Webkit) ──────────────────────────────────────────────────── */
::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: var(--rm-bg); }
::-webkit-scrollbar-thumb { background: var(--rm-border); border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: #afafaf; }

/* ── Buttons (global override) ───────────────────────────────────────────── */
button {
  cursor: pointer;
  font-family: inherit;
}

/* ── Inputs (global override) ────────────────────────────────────────────── */
input, select, textarea {
  font-family: inherit;
}

/* ── SweetAlert2 primary color override ──────────────────────────────────── */
.swal2-confirm {
  background-color: var(--rm-primary) !important;
  border-color: var(--rm-primary) !important;
}
.swal2-confirm:hover {
  background-color: var(--rm-primary-hover) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,4CAA4C;EAC5C,2CAA2C;;EAE3C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;;EAE9B,+CAA+C;EAC/C,+CAA+C;EAC/C,yBAAyB;;EAEzB,wDAAwD;EACxD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,qBAAqB;EACrB,yGAAyG;EACzG,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA,+EAA+E;AAC/E,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,wBAAwB,EAAE;AACtD,4BAA4B,4BAA4B,EAAE,kBAAkB,EAAE;AAC9E,kCAAkC,mBAAmB,EAAE;;AAEvD,+EAA+E;AAC/E;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,oBAAoB;AACtB;;AAEA,+EAA+E;AAC/E;EACE,8CAA8C;EAC9C,0CAA0C;AAC5C;AACA;EACE,oDAAoD;AACtD","sourcesContent":["/* ── Remanet design tokens ───────────────────────────────────────────────── */\r\n:root {\r\n  --rm-primary:        #269044;\r\n  --rm-primary-hover:  #1e7438;\r\n  --rm-primary-dim:    rgba(38, 144, 68, 0.10);\r\n  --rm-primary-border: rgba(38, 144, 68, 0.4);\r\n\r\n  --rm-bg:             #f1f1f1;\r\n  --rm-surface:        #ffffff;\r\n  --rm-surface-raised: #f8f8f8;\r\n  --rm-border:         #d3d3d3;\r\n  --rm-border-light:   #e8e8e8;\r\n\r\n  --rm-text:           #202020;\r\n  --rm-text-muted:     #7c7c7c;\r\n\r\n  --rm-radius:         6px;\r\n  --rm-radius-lg:      10px;\r\n  --rm-transition:     0.2s ease;\r\n\r\n  --rm-shadow-sm:      0 1px 3px rgba(0,0,0,0.07);\r\n  --rm-shadow-md:      0 2px 8px rgba(0,0,0,0.09);\r\n  --rm-header-height:  60px;\r\n\r\n  /* Panel label style (reusable as JS object reference) */\r\n  --rm-label-size:     11px;\r\n  --rm-label-spacing:  0.08em;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  background-color: var(--rm-bg);\r\n  color: var(--rm-text);\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  min-height: 100vh;\r\n  overflow-x: hidden;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\r\n}\r\n\r\n/* ── Scrollbar (Webkit) ──────────────────────────────────────────────────── */\r\n::-webkit-scrollbar { width: 8px; height: 8px; }\r\n::-webkit-scrollbar-track { background: var(--rm-bg); }\r\n::-webkit-scrollbar-thumb { background: var(--rm-border); border-radius: 4px; }\r\n::-webkit-scrollbar-thumb:hover { background: #afafaf; }\r\n\r\n/* ── Buttons (global override) ───────────────────────────────────────────── */\r\nbutton {\r\n  cursor: pointer;\r\n  font-family: inherit;\r\n}\r\n\r\n/* ── Inputs (global override) ────────────────────────────────────────────── */\r\ninput, select, textarea {\r\n  font-family: inherit;\r\n}\r\n\r\n/* ── SweetAlert2 primary color override ──────────────────────────────────── */\r\n.swal2-confirm {\r\n  background-color: var(--rm-primary) !important;\r\n  border-color: var(--rm-primary) !important;\r\n}\r\n.swal2-confirm:hover {\r\n  background-color: var(--rm-primary-hover) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
